export const icons = [
  'Apple',
  'Aubergine',
  'Bacon',
  'Pepper',
  'Banana',
  'Bread',
  'Broccoli',
  'Carrot',
  'Cereal',
  'Cherry',
  'Chicken breast',
  'Chili',
  'Croissant',
  'Egg',
  'Grape',
  'Ham',
  'Hamburger',
  'Herb',
  'Lemon',
  'Milk',
  'Mushroom',
  'Orange',
  'Pepper',
  'Salmon',
  'Strawberry',
  'Sweetcorn',
  'Tomato',
  'Watermelon',
];
